import { Module } from './Module';
/**
 * A class for Components.
 */
export class Component extends Module {
    /**
     * Add a single plugin
     */
    addPlugin(plugin) {
        if (typeof this._plugins === 'undefined') {
            this._plugins = [];
        }
        this._plugins.push(plugin);
        if (!plugin.inited) {
            plugin.initPlugin(this);
        }
    }
    /**
     * Destroy all plugins
     */
    _destroyPlugins() {
        if (this._plugins) {
            this._plugins.forEach((plugin) => {
                plugin.destroy();
            });
        }
    }
    _destroy() {
        super._destroy();
        this._destroyPlugins();
    }
}
